import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "draggable-upload-item" }
const _hoisted_2 = ["src", "onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "mb-flie-list"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "form-upload-img-icon-area" }
const _hoisted_7 = { class: "ant-upload-text" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draggable = _resolveComponent("draggable")!
  const _component_oio_icon = _resolveComponent("oio-icon")!
  const _component_plus_outlined = _resolveComponent("plus-outlined")!
  const _component_EyeOutlined = _resolveComponent("EyeOutlined")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_oio_modal = _resolveComponent("oio-modal")!

  return (_openBlock(), _createElementBlock("div", {
    class: "oio-default-upload-img dragsort-imageUploader",
    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createVNode(_component_draggable, {
      modelValue: _ctx.innerFileList,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.innerFileList) = $event)),
      "item-key": "url",
      class: "upload-draggable-list",
      disabled: _ctx.readonly || _ctx.disabled,
      move: () => true,
      onEnd: _ctx.onDragEnd
    }, {
      item: _withCtx(({ element }) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            src: element.url,
            alt: "",
            class: "upload-preview-img",
            onClick: _withModifiers(($event: any) => (_ctx.handlePreview(element)), ["stop"])
          }, null, 8, _hoisted_2),
          (!_ctx.readonly && !_ctx.disabled)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "remove-btn",
                onClick: _withModifiers(($event: any) => (_ctx.onRemoveFile(element)), ["stop"])
              }, " × ", 8, _hoisted_3))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "disabled", "move", "onEnd"]),
    ( !_ctx.readonly &&
            (!_ctx.value || (Array.isArray(_ctx.value) ? _ctx.limit && (_ctx.limit === -1 || _ctx.value.length < Number(_ctx.limit)) : Object.keys(_ctx.value).filter((name) => !name.includes('_')).length === 0)))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_FileUpload, {
            value: _ctx.innerFileList,
            listType: "picture-card",
            limit: _ctx.limit,
            "limit-size": _ctx.limitSize,
            "all-limit-size": _ctx.allLimitSize,
            accept: _ctx.limitFileExtensions || '.jpg,.jpeg,.png,.gif,.bmp',
            disabled: _ctx.disabled,
            readonly: _ctx.readonly,
            showUploadList: false,
            managed: _ctx.managed,
            multiple: _ctx.multiple,
            progress: _ctx.progress,
            "cdn-key": _ctx.cdnKey,
            partSize: _ctx.partSize,
            parallel: _ctx.parallel,
            chunkUploadThreshold: _ctx.chunkUploadThreshold,
            onChange: _ctx.onChangeFile,
            onRemove: _ctx.onRemoveFile,
            onPreview: _ctx.handlePreview
          }, {
            previewIcon: _withCtx(({ file, continuedUpload }) => [
              (file.status === 'error')
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    onClick: _withModifiers(continuedUpload, ["stop","prevent"]),
                    title: ""
                  }, [
                    _createVNode(_component_oio_icon, {
                      icon: "oinone-zhongzhi",
                      color: "#fff"
                    })
                  ], 8, _hoisted_8))
                : (_openBlock(), _createBlock(_component_EyeOutlined, { key: 1 }))
            ]),
            default: _withCtx(() => [
              (
            !_ctx.readonly &&
            (!_ctx.value || (Array.isArray(_ctx.value) ? _ctx.limit && (_ctx.limit === -1 || _ctx.value.length < Number(_ctx.limit)) : Object.keys(_ctx.value).filter((name) => !name.includes('_')).length === 0))
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _renderSlot(_ctx.$slots, "default", {}, () => [
                      _createElementVNode("div", _hoisted_6, [
                        (_ctx.uploadIcon)
                          ? (_openBlock(), _createBlock(_component_oio_icon, {
                              key: 0,
                              icon: _ctx.uploadIcon,
                              size: "14"
                            }, null, 8, ["icon"]))
                          : (_openBlock(), _createBlock(_component_plus_outlined, { key: 1 })),
                        _createTextVNode(" " + _toDisplayString(_ctx.uploadIconText), 1)
                      ]),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.uploadPlaceholder || (_ctx.translate && _ctx.translate('kunlun.button.upload')) || _ctx.$translate('点击上传')), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 3
          }, 8, ["value", "limit", "limit-size", "all-limit-size", "accept", "disabled", "readonly", "managed", "multiple", "progress", "cdn-key", "partSize", "parallel", "chunkUploadThreshold", "onChange", "onRemove", "onPreview"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_oio_modal, {
      width: "50%",
      visible: _ctx.previewVisible,
      title: _ctx.$translate(_ctx.previewTitle),
      footer: null,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.previewVisible = false)),
      onCancel: _ctx.handleCancel
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          alt: "example",
          style: {"width":"100%"},
          src: _ctx.previewImage
        }, null, 8, _hoisted_9)
      ]),
      _: 1
    }, 8, ["visible", "title", "onCancel"])
  ]))
}